import { useCrmStore } from "features/Crm/store/useCrmStore";

export const useEditCustomColumnModal = () => {
  const setIsEditCustomColumnModalOpen = useCrmStore(
    (state) => state.setIsEditCustomColumnModalOpen
  );
  const isEditCustomColumnModalOpen = useCrmStore(
    (state) => state.isEditCustomColumnModalOpen
  );
  const setActiveCustomColumn = useCrmStore(
    (state) => state.setActiveCustomColumn
  );

  const openEditCustomColumnModal = (column) => {
    setActiveCustomColumn(column);
    setIsEditCustomColumnModalOpen(true);
  };
  const closeEditCustomColumnModal = () => {
    setIsEditCustomColumnModalOpen(false);
    setActiveCustomColumn(null);
  };

  return {
    isEditCustomColumnModalOpen,
    openEditCustomColumnModal,
    closeEditCustomColumnModal,
  };
};
